import React from 'react';
import { CalendarPlusIcon, BellIcon, TicketIcon, ShareIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import type { FullEventData } from '../../data/eventSchema';
interface ActionButtonsProps {
  event: FullEventData;
}
export const ActionButtons: React.FC<ActionButtonsProps> = ({
  event
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const isUpcoming = event.status === 'upcoming' || event.status === 'tickets-live';
  return <div className={`p-6 rounded-xl shadow-sm border sticky top-24 ${dk.card} ${dk.border}`} data-id="element-8863" data-mp="1yd6i978y8usj">
      {/* Primary CTA */}
      {event.accessRules.ticketRequired && event.accessRules.ticketLink && isUpcoming ? <a href={event.accessRules.ticketLink} target="_blank" rel="noopener noreferrer" className={`w-full flex items-center justify-center px-4 py-3 rounded-lg font-bold text-white mb-4 transition-colors ${rt.primaryButton}`} data-id="element-8864" data-mp="hxvl6fb5yvn5">
          <TicketIcon className="w-5 h-5 mr-2" data-id="element-8865" data-mp="29quwgyt1y772" />
          Get Tickets
        </a> : isUpcoming && !event.accessRules.ticketRequired ? <button className={`w-full flex items-center justify-center px-4 py-3 rounded-lg font-bold text-white mb-4 transition-colors ${rt.primaryButton}`} data-id="element-8866" data-mp="1zvb58ppfnwon">
          <TicketIcon className="w-5 h-5 mr-2" data-id="element-8867" data-mp="1q4yicqu5brfc" />
          RSVP for Free
        </button> : null}

      {/* Secondary Actions */}
      <div className="space-y-3 mb-6" data-id="element-8868" data-mp="1uw88rtniqysa">
        {event.visibility.allowCalendar && <button className={`w-full flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${dk.border} ${dk.textPrimary} hover:${dk.surfaceMuted}`} data-id="element-8869" data-mp="1h533oc1dteak">
            <CalendarPlusIcon className="w-4 h-4 mr-2" data-id="element-8870" data-mp="176dwbd743c8k" />
            Add to Calendar
          </button>}

        {event.visibility.allowReminders && <button className={`w-full flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${dk.border} ${dk.textPrimary} hover:${dk.surfaceMuted}`} data-id="element-8871" data-mp="t0u2y3z24b6p">
            <BellIcon className="w-4 h-4 mr-2" data-id="element-8872" data-mp="jbkauo47qsil" />
            Get Reminder
          </button>}

        <button className={`w-full flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${dk.border} ${dk.textPrimary} hover:${dk.surfaceMuted}`} data-id="element-8873" data-mp="ech2atp0y45v">
          <ShareIcon className="w-4 h-4 mr-2" data-id="element-8874" data-mp="171ei8q5rjovg" />
          Share Event
        </button>
      </div>

      {/* Ticket Tiers Summary */}
      {event.accessRules.ticketRequired && event.accessRules.ticketTiers.length > 0 && <div className={`pt-6 border-t ${dk.border}`} data-id="element-8875" data-mp="x49vao43fpdl">
            <h3 className={`text-sm font-bold uppercase tracking-wider mb-4 ${dk.textMuted}`} data-id="element-8876" data-mp="3ms0tzoa1reit">
              Ticket Options
            </h3>
            <div className="space-y-3" data-id="element-8877" data-mp="1xam1n51mnqqs">
              {event.accessRules.ticketTiers.map(tier => <div key={tier.id} className={`p-3 rounded-lg border ${tier.soldOut ? `opacity-60 ${dk.surfaceMuted}` : dk.surface} ${dk.border}`} data-id="element-8878" data-mp="228nl3r2yts2s">
                  <div className="flex justify-between items-start mb-1" data-id="element-8879" data-mp="2bz9u32g6fkci">
                    <span className={`font-semibold ${dk.textPrimary}`} data-id="element-8880" data-mp="2gy38cx3affdq">
                      {tier.name}
                    </span>
                    <span className={`font-bold ${dk.textPrimary}`} data-id="element-8881" data-mp="2kyn53zjy8gzc">
                      {tier.price === 0 ? 'Free' : `${tier.price} ${tier.currency}`}
                    </span>
                  </div>
                  <p className={`text-xs ${dk.textSecondary}`} data-id="element-8882" data-mp="2uvi1absr25ag">
                    {tier.description}
                  </p>
                  {tier.soldOut && <span className="inline-block mt-2 text-xs font-bold text-red-500 uppercase" data-id="element-8883" data-mp="10kmm2qn27ryp">
                      Sold Out
                    </span>}
                </div>)}
            </div>
          </div>}
    </div>;
};